import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';


import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { AuthRoutingModule } from './auth-routing.module';

@NgModule({
  declarations: [
    SigninComponent,
    SignupComponent
  ],
  imports: [
  	BrowserModule,
    FormsModule,
    AuthRoutingModule
  ]
})
export class AuthModule {}



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts